import { createStore } from "satcheljs";

export enum LandingPageMode {
    NotInitialized = "NotInitialized",
    ShowCreateNewSchedule = "ShowCreateNewSchedule",
    ShowScheduleTeamSwitcher = "ShowScheduleTeamSwitcher",
    ShowEmptyMessageNoTeams = "ShowEmptyScreenNoTeams",
    ShowEmptyMessageNoSchedulesForTeams = "ShowEmptyMessageNoSchedulesForTeams",
    ShowUserOnboardingFLM = "ShowUserOnboardingFLM",
    ShowUserOnboardingFLW = "ShowUserOnboardingFLW"
}

export interface LandingPageViewState {
    landingPageMode: LandingPageMode;
    canCreateTeam: boolean | undefined;
}

let initialLandingPageViewState: LandingPageViewState = {
    landingPageMode: LandingPageMode.NotInitialized,
    canCreateTeam: undefined
};

export let landingPageViewState = createStore<LandingPageViewState>("landingPageViewState", initialLandingPageViewState);